(function () {
  class ProductAtcCta {
    constructor(section) {
      this.section = section;
      this.form = section.querySelector('form');
      this.variantInput = section.querySelector('[data-patc-variant-id]');
      this.price = section.querySelector('[data-patc-price]');
      this.button = section.querySelector('[data-patc-submit]');
      this.buttonLabel = section.querySelector('[data-patc-label]');
      this.variants = this.parseVariants();
      this.preorderVariantIds = this.parsePreorderVariantIds();
      this.backorderVariantIds = this.parseBackorderVariantIds();
      this.moneyFormat = section.dataset.moneyFormat || '${{amount}}';
      this.addLabel = section.dataset.addLabel || 'Add to Cart';
      this.preorderLabel = section.dataset.preorderLabel || 'Pre-order Now';
      this.backorderLabel = section.dataset.backorderLabel || 'Backorder Now';
      this.soldOutLabel = section.dataset.soldOutLabel || 'Out of Stock';
      this.unavailableLabel = section.dataset.unavailableLabel || 'Unavailable';

      if (!this.variantInput || !this.button) return;

      this.syncFromMainForm();
      this.bindEvents();
    }

    parseVariants() {
      try {
        return JSON.parse(this.section.querySelector('[data-patc-variants]')?.textContent || '[]');
      } catch (error) {
        return [];
      }
    }

    parseBackorderVariantIds() {
      try {
        return new Set(JSON.parse(this.section.querySelector('[data-patc-backorder-variants]')?.textContent || '[]').map(String));
      } catch (error) {
        return new Set();
      }
    }

    parsePreorderVariantIds() {
      try {
        return new Set(JSON.parse(this.section.querySelector('[data-patc-preorder-variants]')?.textContent || '[]').map(String));
      } catch (error) {
        return new Set();
      }
    }

    bindEvents() {
      document.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="id"].product-variant-id')) return;
        if (this.section.contains(event.target)) return;
        this.updateFromVariantId(event.target.value);
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant || event?.variant;
          if (variant?.id) this.updateFromVariantId(String(variant.id), variant);
        });
      }

      document.addEventListener('click', (event) => {
        const selector = event.target.closest('[data-variant-id]');
        if (!selector || this.section.contains(selector)) return;
        const variantId = selector.getAttribute('data-variant-id');
        if (variantId) window.setTimeout(() => this.updateFromVariantId(variantId), 60);
      });
    }

    syncFromMainForm() {
      const mainInput = document.querySelector('product-info input[name="id"].product-variant-id, product-info form[action*="/cart/add"] input[name="id"]');
      if (mainInput?.value) this.updateFromVariantId(mainInput.value);
      else this.updateFromVariantId(this.variantInput.value);
    }

    getVariant(variantId, fallbackVariant) {
      return this.variants.find((variant) => String(variant.id) === String(variantId)) || fallbackVariant || null;
    }

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, this.moneyFormat);
      }

      const amount = (Number(cents || 0) / 100).toFixed(2);
      return '$' + amount.replace('.00', '');
    }

    updateFromVariantId(variantId, fallbackVariant) {
      if (!variantId) return;

      const variant = this.getVariant(variantId, fallbackVariant);
      this.variantInput.value = variantId;

      const isAvailable = variant ? variant.available !== false : true;
      const isPreorder = this.preorderVariantIds.has(String(variantId));
      const isBackorder = !isPreorder && this.backorderVariantIds.has(String(variantId));
      const canSubmit = isAvailable || isPreorder || isBackorder;
      this.button.disabled = !canSubmit;
      this.button.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
      if (this.buttonLabel) {
        this.buttonLabel.textContent = isPreorder ? this.preorderLabel : (isBackorder ? this.backorderLabel : (isAvailable ? this.addLabel : this.soldOutLabel));
      }
      if (this.price && variant?.price != null) this.price.textContent = this.formatMoney(variant.price);
    }
  }

  function initProductAtcCtas(scope) {
    (scope || document).querySelectorAll('[data-product-atc-cta]').forEach((section) => {
      if (section.dataset.productAtcCtaReady === 'true') return;
      section.dataset.productAtcCtaReady = 'true';
      new ProductAtcCta(section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initProductAtcCtas(document));
  document.addEventListener('shopify:section:load', (event) => initProductAtcCtas(event.target));
})();
